import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DiscountCouponService from "./Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import Select from 'react-select';
import { Col, CardBody, Card } from "reactstrap";
import PermissionAccess from '../../PermissionAccess/Access.js';

const AddDiscountCouponModal = ({ showModalAddDiscountCoupon, handleToggleModalAddDiscountCoupon, onSuccess }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [data, setData] = useState({
    name: '',
    type: '',
  });


  const [errors, setErrors] = useState({
    name: '',
    type: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target || e;
    let error = '';
  
      // Handle other fields as before
      if (name === 'name' && !value) {
        error = 'Name is required';
      }  else if (name === 'type') {
        if (!value) error = 'Type is required';
        setType(value);
      } 
      setData(prevData => ({ ...prevData, [name]: value }));
    
  
    setErrors(prevErrors => ({ ...prevErrors, [name]: error }));
  };
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!data.name) { validationErrors.name = 'Name is required'; }
    if (!data.type) { validationErrors.type = 'type is required'; }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      DiscountCouponService.AddSpecialization(authData.sessionID,data).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          if (response.data.status === true) {
            resetForm();
            handleToggleModalAddDiscountCoupon();
            onSuccess();
            validationErrors.name = '';
            Alerts.swalSuccessAlert(t("Specialization added successfully."));
          } else {
            validationErrors.name = response.data.errors[0].message || 'An error occurred';
            setErrors(validationErrors);
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
    }
  };

  const resetForm = () => {
    setData({
      name: '',
      type: '',
    });
    setErrors({
      coupon_code: '',
    });
  };

  const handleClose = () => {
    setErrors({
        name: '',
        type: '',
    });
    handleToggleModalAddDiscountCoupon();
  };

  return (
    <div className={showModalAddDiscountCoupon ? "modal d-block mt-4" : "modal"} style={{ display: showModalAddDiscountCoupon ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1" role="dialog">
      <form onSubmit={handleSubmit}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{t("Add Specialization")}</h5>
            </div>
            <div className="modal-body">
            <Col md="12">
                <Card className="main-card mb-3">
                     <CardBody>
              <LoadingOverlay
                tag="div"
                active={loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}
              >
                <input type="hidden" className="form-control" name="business_id" />

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="coupon-code" className="col-form-label">{t("Name")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Name" 
                      name="name"
                      onChange={handleChange}
                      value={data.name}
                      />
                      {errors.name && <strong className="error text-danger">{errors.name}</strong>}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="type-select" className="col-form-label">{t("Type")}:</label>
                      <select className="form-control"
                      name="type"
                      onChange={handleChange}
                      value={data.type}
                      >
                        <option value="">{t("Select Type")}</option>
                        <option value="Doctor">{t("Doctor")}</option>
                        <option value="Nurse">{t("Nurse")}</option>
                        <option value="Both">{t("Both")}</option>
                      </select>
                      {errors.type && <strong className="error text-danger">{errors.type}</strong>}
                    </div>
                  </div>

                  
                </div>

                

                <div className="row">
                 
                  
                  <div className="text-center mt-4">
                  <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleClose}>{t("Close")}</button>
                  <button type="submit" className="btn btn-custom-color">{t("Save")}</button>
                </div>
                </div>
                                          </LoadingOverlay>
                                        </CardBody>
                                    </Card>
                                </Col>
            </div>
            
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddDiscountCouponModal;

